/**
 * Formats a date as `YYYY-MM-DD` from its *local* calendar date -- the value
 * format of `<input type="date">`.
 *
 * Not `toISOString().split("T")[0]`: that formats the UTC instant, so a local
 * midnight anywhere east of UTC lands on the previous calendar day, and the
 * 1st of a month comes out as the 30th or 31st of the one before.
 * @param date
 */
export const toYYYYMMDD = (date: Date) => {
    const year = date.getFullYear();
    const month = `${date.getMonth() + 1}`.padStart(2, "0");
    const day = `${date.getDate()}`.padStart(2, "0");

    return `${year}-${month}-${day}`;
};
